// components
import { Radiobutton } from '@tajawal/ct-web-design-system';

// types
import { FILTER_DUMMY_ANY_OPTION } from '@/constants/common.constants';
import type SingleSelectFilterType from '@tajawal/web-flights-sdk/lib/stores/filter/base/single-select-filter.store';

// hooks
import useSingleSelectFilter from '@/hooks/useSingleSelectFilter';
import { useTranslation } from 'react-i18next';

export type SingleSelectFilterProps = {
  filter: SingleSelectFilterType;
  testId: string;
  isDesktop?: boolean;
};

function SingleSelectFilter({ filter, testId, isDesktop }: SingleSelectFilterProps): JSX.Element {
  const { t } = useTranslation();
  const { handleSelect, options, selectedItem } = useSingleSelectFilter(filter, t);

  return (
    <Radiobutton
      isSingle={isDesktop}
      onChange={handleSelect}
      testId={testId}
      value={selectedItem !== undefined ? String(selectedItem) : FILTER_DUMMY_ANY_OPTION}
      options={options}
    />
  );
}

export default SingleSelectFilter;
